import Fuse, { type FuseOptionKey, type IFuseOptions } from "fuse.js";

const fuseOptions = <T>(keys: Array<FuseOptionKey<T>>): IFuseOptions<T> => {
	return {
		isCaseSensitive: false,
		keys,
		minMatchCharLength: 3,
		// includeMatches: false,
		// findAllMatches: false,
		// location: 0,
		threshold: 0,
		// distance: 100,
		// useExtendedSearch: false,
		ignoreLocation: true,
		// ignoreFieldNorm: false,
	};
};

export const search = <T>(searchStr: string, items: T[], keys: Array<FuseOptionKey<T>>): T[] => {
	const options = fuseOptions<T>(keys);
	const fuse = new Fuse(items, options);
	const searchResults = fuse.search(searchStr);
	return searchResults.map((result) => result.item);
};
